module.exports = __webpack_public_path__ + "img/图层 23.10fbd6d2.png";